import React from 'react'

export const CardArt = () => {
  return <img src={`${process.env.ASSETS_URL}/cards/card-art.svg`} alt="Vector" />
}
